<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 496.941 496.941" style="enable-background:new 0 0 496.941 496.941;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M113.694,137.788c38.4,0,69.271-30.871,69.271-68.518S151.341,0,113.694,0C76.047,0,44.424,30.871,44.424,68.518
				S75.294,137.788,113.694,137.788z M113.694,15.059c30.118,0,54.212,24.094,54.212,53.459s-24.094,53.459-54.212,53.459
				c-30.118,0-54.212-24.094-54.212-53.459S83.576,15.059,113.694,15.059z"/>
			<path d="M226.635,252.235v-40.659c0-38.4-31.624-70.024-70.024-70.024H70.024C31.624,142.306,0,173.176,0,212.329v40.659
				c0,4.518,3.012,7.529,7.529,7.529h211.576C223.624,259.765,226.635,256.753,226.635,252.235z M211.576,244.706H15.059v-33.129
				c0-30.118,24.847-54.965,54.965-54.965h86.588c30.118,0,54.965,24.847,54.965,54.965V244.706z"/>
			<path d="M383.247,237.176c-38.4,0-69.271,30.871-69.271,68.518c0,37.647,30.871,68.518,69.271,68.518
				s69.271-30.871,69.271-68.518C452.518,268.047,421.647,237.176,383.247,237.176z M383.247,359.153
				c-30.118,0-54.212-24.094-54.212-53.459s24.094-53.459,54.212-53.459c30.118,0,54.212,24.094,54.212,53.459
				S413.365,359.153,383.247,359.153z"/>
			<path d="M426.918,378.729h-86.588c-38.4,0-70.023,31.624-70.023,70.024v40.659c0,4.518,3.012,7.529,7.529,7.529h211.576
				c4.518,0,7.529-3.012,7.529-7.529v-40.659C496.941,410.353,465.318,378.729,426.918,378.729z M481.882,481.882H285.365v-33.129
				c0-30.118,24.847-54.965,54.965-54.965h86.588c30.118,0,54.965,24.847,54.965,54.965V481.882z"/>
			<path d="M336.565,195.012c2.259-1.506,4.518-3.765,4.518-6.776v-21.082h85.082c1.506,0,3.765-0.753,5.271-2.259
				c1.506-1.506,2.259-3.012,2.259-5.271v-58.729c0-4.518-3.012-7.529-7.529-7.529h-85.082V72.282c0-3.012-1.506-5.271-4.518-6.776
				c-2.259-1.506-5.271-0.753-8.282,0.753l-75.294,57.976c-1.506,1.506-3.012,3.765-3.012,6.023c0,2.259,0.753,4.518,3.012,6.024
				l74.541,57.976C330.541,195.765,333.553,195.765,336.565,195.012z M325.271,172.424l-54.965-42.918l55.718-42.165v12.8
				c0,4.518,3.012,7.529,7.529,7.529h85.082v43.671h-85.082c-2.259,0-3.765,0.753-5.271,2.259c-2.259,2.259-3.012,3.765-3.012,6.024
				V172.424z"/>
			<path d="M234.165,380.235l-75.294-57.977c-2.259-1.506-5.271-2.259-8.282-0.753c-2.259,1.506-4.518,3.765-4.518,6.776v21.082
				H67.765c-4.518,0-7.529,3.012-7.529,7.529v58.729c0,2.259,0.753,3.765,2.259,5.271c1.506,1.506,3.012,2.259,5.271,2.259h78.306
				v21.082c0,3.012,1.506,5.271,4.518,6.776c2.259,1.506,5.271,0.753,8.282-0.753l75.294-57.977
				c1.506-1.506,3.012-3.765,3.012-6.023C237.176,384,236.424,381.741,234.165,380.235z M161.129,429.176v-12.8
				c0-2.259-0.753-3.765-2.259-5.271c-1.506-1.506-3.012-2.259-5.271-2.259H75.294v-43.671H153.6c4.518,0,7.529-3.012,7.529-7.529
				v-12.8l54.965,42.918L161.129,429.176z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
